export default __webpack_public_path__ + "static/invoiceListUnpaid-ba5c4a96b4dea5055cf370f81eb20c91.webp";